<template>
    <div class="index-box">
         <img src="@/m/images/banner.png" width="100%">
         <div style="clear:both;"></div>
         <router-link :to="'/timeline'">
             <img src="@/m/images/time.png" width="21%" class="time">
         </router-link>
         <a href="http://www.zzpxx.com " target="_blank">
            <img src="@/m/images/about.png" width="21%" class="about">
         </a>
         <yd-button size="large" type="primary" shape="circle" bgcolor="#369567" color="#fff" class="btn" @click.native="goto('campus')">申请职位</yd-button>
         <!--<yd-button size="large" type="primary" shape="circle" bgcolor="#369567" color="#fff" class="btn" @click.native="show = true">申请职位</yd-button>-->
         <!--<yd-popup v-model="show" position="center" width="75%">-->
            <!--<div class="tc-box">-->
                <!--<div class="sec-con" @click="goto('campus')">-->
                     <!--<img src="@/m/images/freshgra.png" width="70%">-->
                     <!--<p>校园招聘</p>-->
                <!--</div>-->
                <!--<div class="sec-con" @click="goto('social')">    -->
                    <!--<img src="@/m/images/exper.png" width="70%">-->
                    <!--<p>社会招聘</p>-->
                <!--</div> -->
                <!--<div style="clear:both;"></div>-->
                <!--&lt;!&ndash; <yd-button @click.native="show = false">Close</yd-button> &ndash;&gt;-->
            <!--</div>-->
        <!--</yd-popup>-->
    </div>
</template>
<script>
export default {
        data() {
            return {
                show: false
            }
        },
         methods:{
            goto(name){
                this.show=false;
                this.$router.push({name:name})
            }
        }
    }
</script>
<style scoped>
.index-box{
    min-height: 92.5vh;
    padding-bottom: 10px;
    position: relative;
}
.about{
    position: absolute;
    top: 23%;
    left: 19%;
}
.time{
    position: absolute;
    top: 9%;
    left: 44%;
}
.btn{
    font-family: '微软雅黑';
    width: 76%;
    font-size: .3rem;
    height: .9rem;
    box-shadow: 0px 10px 10px -10px  rgba(53, 147, 102, .8);
    position: absolute;
    left: 12%;
    bottom: 20px;
}
.tc-box {
    border-radius: 5px;
    padding:50px 20px ;
    background-color:#fff;
}
.tc-box .sec-con{
    color: #369567;
    font-size: .26rem;
    width: 50%;
    float: left;
    text-align: center;
}
.tc-box .sec-con p{
    margin-top: 20px;
}
</style>
<style>
.yd-mask{
    background-color:rgb(255, 255, 255)!important;
}
.yd-popup-content{
    box-shadow: 0px 0px 200px 0px #e5e5e5;
}
</style>

